export function getUserRoleLabel(
    api_name?: string | undefined,
    roles?: RoleDto[] | undefined
): string | undefined {
    if (!roles || !api_name) return undefined
    return roles.find((r) => r.api_name === api_name)?.label
}
